import React from "react";
import Body from "./Body";

const ExamResult = () => {
  return <Body />;
};

export default ExamResult;
